import React from 'react';
import styled from 'styled-components';

// Says why Update is disabled for want of a report. Used to read "Please
// upload a report" whatever the reason, including for a report that had been
// created and then stopped matching the inspection.
const ReportRequiredMessage = ({ message }: { message: string }) => {
  return <>{message && <Wrapper>{message}</Wrapper>}</>;
};

export default ReportRequiredMessage;

const Wrapper = styled.div`
  color: red;
  width: 100%;
  text-align: center;
  font-size: 12px;
`;
